import React from "react";
import { HiOutlineCake } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneFood } from "../../../lib/sysNavigation/SysNavigation";

type FoodRow = {
  food_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<FoodRow>
    type={_TYPES_.FOOD}
    title="Food"
    subtitle="Food content promoted on the public site."
    icon={<HiOutlineCake className="h-5 w-5" />}
    addRoute="/data/food/add"
    editRoute="/data/food/edit"
    pushOne={pushOneFood}
    dataKey="foods"
    countKey="foodsCount"
    idField="food_id"
  />
);

export default Overview;
